<script>
    export let rows = 1;
    export let width = "100%";
    export let height = "16px";
    export let className = "";
    export let hasTransition = false;
    export let transitionDelay = 0;
</script>

<div class="skeleton-container {className}">
    {#each Array(rows) as _, i}
        <div 
            class="skeleton-item {hasTransition ? 'has-width-transition default-hide' : ''} rounded-3" 
            style="width: {width}; height: {height}; margin-bottom: {i === rows - 1 ? '0' : '0.5rem'}; 
            {hasTransition ? `animation-delay: ${transitionDelay}s;` : ''}"
        ></div>
    {/each}
</div>

<style>
    .skeleton-container {
        width: 100%;
    }
    
    .skeleton-item {
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
        border-radius: 4px;
        opacity: 1;
    }

    .default-hide {
        opacity: 0;
    }
    
    .has-width-transition {
        width: 0%;
        transition: width 1s ease-in-out;
        animation: width-expand 5s forwards, shimmer 1.5s infinite;
    }
    
    @keyframes shimmer {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
    
    @keyframes width-expand {
        0% {
            opacity: 0;
            width: 0%;
        }
        100% {
            opacity: 1;
            width: 100%;
        }
    }
</style>